<template>
    <div class="p-4 bg-surface-50 border border-surface-200 rounded-lg mb-4">
        <div class="flex items-center gap-2 mb-2">
            <i class="pi pi-info-circle text-primary-500 text-sm"></i>
            <span class="text-sm font-semibold text-surface-900">{{ $t('This article accepts') }}</span>
        </div>

        <div class="flex items-center gap-3 flex-wrap">
            <!-- Accepted Anchors + Max Images in same badge -->
            <div class="inline-flex items-center gap-3 px-2 py-1 bg-primary-50 border border-primary-200 rounded-lg shrink-0">
                <div class="flex items-center gap-1.5">
                    <i class="pi pi-link text-primary-600 text-xs"></i>
                    <span class="text-xs font-medium text-surface-700">{{ $t('Accepted Anchors') }}:</span>
                    <span class="text-xs font-bold text-primary-600">{{ computedAcceptedAnchors }}</span>
                </div>
                <div v-if="features.images" class="flex items-center gap-1.5 border-l border-primary-200 pl-3">
                    <i class="pi pi-image text-blue-600 text-xs"></i>
                    <span class="text-xs font-medium text-surface-700">{{ $t('Max images') }}:</span>
                    <span class="text-xs font-bold text-blue-600">{{ features.images }}</span>
                </div>
            </div>

            <!-- Available Features -->
            <div v-if="features.menu" class="flex items-center gap-1.5 shrink-0">
                <i class="pi pi-check-circle text-green-600 text-xs"></i>
                <span class="text-xs text-surface-700">{{ $t('Menu') }}</span>
            </div>
            <div v-if="features.banner" class="flex items-center gap-1.5 shrink-0">
                <i class="pi pi-check-circle text-green-600 text-xs"></i>
                <span class="text-xs text-surface-700">{{ $t('Banner') }}</span>
            </div>
            <div v-if="features.promo" class="flex items-center gap-1.5 shrink-0">
                <i class="pi pi-check-circle text-green-600 text-xs"></i>
                <span class="text-xs text-surface-700">{{ $t('Promo') }}</span>
            </div>
            <div v-if="features.google_news" class="flex items-center gap-1.5 shrink-0">
                <i class="pi pi-check-circle text-green-600 text-xs"></i>
                <span class="text-xs text-surface-700">{{ $t('Google News') }}</span>
            </div>
            <div v-if="features.embed" class="flex items-center gap-1.5 shrink-0">
                <i class="pi pi-check-circle text-green-600 text-xs"></i>
                <span class="text-xs text-surface-700">{{ $t('Embed') }}</span>
            </div>

            <!-- Restriction -->
            <div v-if="features.restrict" class="flex items-center gap-1.5 shrink-0">
                <i class="pi pi-exclamation-triangle text-orange-600 text-xs"></i>
                <span class="text-xs text-surface-700">{{ $t('Restriction') }}:</span>
                <span v-if="features.restrict_detail" class="text-xs text-surface-500 italic">{{ features.restrict_detail }}</span>
            </div>

            <!-- Archive Article -->
            <div v-if="features.archive_article" class="flex items-center gap-1.5 shrink-0">
                <i class="pi pi-clock text-blue-600 text-xs"></i>
                <span class="text-xs text-surface-700">{{ $t('Archive article') }}:</span>
                <span v-if="features.archive_due" class="text-xs text-surface-500 italic">{{ features.archive_due }}</span>
            </div>
        </div>

        <!-- Extra slot for additional content (e.g., Site URL) -->
        <slot />
    </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const props = defineProps({
    features: {
        type: Object,
        required: true
    },
    acceptedAnchors: {
        type: [Number, String],
        default: null
    }
});

const computedAcceptedAnchors = computed(() => {
    if (props.acceptedAnchors !== null && props.acceptedAnchors !== undefined) {
        return props.acceptedAnchors;
    }
    return props.features?.accepted_anchors || 1;
});
</script>
